var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEDBE"
    },
    d: "M339.053,512H68.096c-11.28,0-20.426-9.145-20.426-20.426V20.426C47.67,9.145,56.816,0,68.096,0 h375.788c11.28,0,20.426,9.145,20.426,20.426v366.32c0,5.418-2.153,10.613-5.983,14.444L353.496,506.018 C349.665,509.849,344.47,512,339.053,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE49C"
    },
    d: "M443.882,0H255.989v512h83.064c5.417,0,10.613-2.151,14.442-5.983l104.829-104.829 c3.83-3.83,5.983-9.025,5.983-14.444V20.426C464.308,9.145,455.164,0,443.882,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M244.299,343.345h-30.603v-30.604c0-11.28-9.145-20.426-20.426-20.426s-20.426,9.145-20.426,20.426 v30.604h-30.604c-11.28,0-20.426,9.145-20.426,20.426s9.145,20.426,20.426,20.426h30.604V414.8c0,11.28,9.145,20.426,20.426,20.426 s20.426-9.145,20.426-20.426v-30.604h30.603c11.28,0,20.426-9.145,20.426-20.426C264.724,352.489,255.581,343.345,244.299,343.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M247.819,249.153H142.242c-11.28,0-20.426-9.145-20.426-20.426s9.145-20.426,20.426-20.426h105.577 c11.28,0,20.426,9.145,20.426,20.426S259.099,249.153,247.819,249.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M369.736,186.469H142.242c-11.28,0-20.426-9.145-20.426-20.426s9.145-20.426,20.426-20.426h227.494 c11.28,0,20.426,9.145,20.426,20.426S381.016,186.469,369.736,186.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M369.736,123.783H142.242c-11.28,0-20.426-9.145-20.426-20.426s9.145-20.426,20.426-20.426h227.494 c11.28,0,20.426,9.145,20.426,20.426S381.016,123.783,369.736,123.783z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M264.724,363.771c0-6.93-3.459-13.042-8.735-16.735v33.471 C261.266,376.813,264.724,370.699,264.724,363.771z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M268.244,228.728c0-8.373-5.044-15.562-12.255-18.714v37.429 C263.201,244.288,268.244,237.101,268.244,228.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M369.736,145.618H255.989v40.851h113.747c11.28,0,20.426-9.145,20.426-20.426 S381.016,145.618,369.736,145.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M369.736,82.932H255.989v40.851h113.747c11.28,0,20.426-9.145,20.426-20.426 S381.016,82.932,369.736,82.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M339.049,512c-11.22,0-20.421-9.103-20.421-20.426V386.745c0-11.28,9.145-20.426,20.426-20.426 h104.829c18.126,0,27.302,22.009,14.442,34.869L353.495,506.018C349.588,509.926,344.364,512,339.049,512z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.ce71f3f3254641ac98844b47deedbcae.svg";
export { ForwardRef as ReactComponent };